import React from 'react';

export const BaseSystemPlugin = React.forwardRef<
    HTMLDivElement,
    {
        name?: string;
        children: React.ReactNode;
    }
>(({ name, children }, ref) => {
    return (
        <div ref={ref} className="editor-plugin" data-plugin={name}>
            {children}
        </div>
    );
});

BaseSystemPlugin.displayName = 'BaseSystemPlugin';
